<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Add duration
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.pt-6.pb-3
      .text-md.font-semibold.neutral700--text You can add more than one duration at one time
      v-form.mt-3(ref="form")
        div.text-sm.font-semibold.neutral500--text Duration name
        v-row.mt-4(v-for="(duration, idx) in durations" align="center" no-gutters :key="'dg-' + idx")
          v-col
            v-text-field.text-sm.round-xl(v-model="duration.value" placeholder="Enter duration name" outlined dense height="48" :rules="rules.not_empty" hide-details)
          v-col.pl-3.shrink(v-if="idx !== 0")
            v-btn(icon small @click="removeItem(idx)")
              v-icon(color="neutral700") $yzi-trash-03
        y-button.mt-4(v-if="!duration" label="Add more duration" color="neutral700" outlined size="sm" :loading="isLoading" @click="addItem")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Confirm" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentDuration: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isFetching: false,
    isLoading: false,
    durations: [{}],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
      has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
      not_empty_select: [v => !!v || 'This field is required']
    },
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    duration: {
      get () {
        return this.parentDuration 
      },
      set (newValue) {
        this.$emit('update:parentDuration', newValue)
      }
    }
  },
  mounted () {
    if (this.duration) {
      let item = JSON.parse(JSON.stringify(this.duration))
      this.durations.splice(0, 1, item)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.duration) {
        this.$axios.patch(`/options/${this.duration.id}`, { value: this.durations[0].value })
          .then(() => {
            this.$emit('reset')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        let data = this.durations.map(m => { return { ...m, company: this.company.id, field: 'medication.duration' } })
        let error = false
        for (let i = 0; i < data.length; i++) {
          await this.$axios.post('/options', data[i])
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              error = true
            })
          if (error) {
            break
          }
        }
        this.isLoading = false
        this.$emit('reset')
      }
    },
    addItem () {
      this.durations.push({})
    },
    removeItem (idx) {
      this.durations.splice(idx, 1)
    },
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>